
import { defineComponent } from "vue";
import moment from "moment";
export default defineComponent({
  name: "event-timer",
  props: {
    date: {
      type: String,
      required: true,
    },
    isStart: {
      type: Boolean,
      required: true,
    },
    isReset: {
      type: Boolean,
    },
  },
  data() {
    return {
      error: null,
      now: null,
      remaining: null,
      remainingTime: null,
      moment: null,
      mode: 0,
      modes: {
        years: 5,
        months: 4,
        days: 3,
        hours: 2,
        minutes: 1,
      },
    };
  },
  mounted() {
    this.moment = moment.utc(this.date);
    if (this.moment.isValid()) {
      this.tick(0);
    } else {
      this.error = ["-", "Error"];
    }
  },
  beforeUnmount() {
    window.clearTimeout(this.$options.timer);
  },
  methods: {
    zeroPad(num, places) {
      return String(num).padStart(places, "0");
    },
    s(count) {
      if (count !== 1) return "s";
    },
    tick(timeout = 50) {
      this.$options.timer = window.setTimeout(this.updateDateTime, timeout);
    },
    updateDateTime() {
      const duration = moment.duration(this.moment.diff(moment()));
      this.remaining = {
        years: duration.years(),
        months: duration.months(),
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      };
      if (this.remaining.years > 0) this.mode = this.modes.years;
      else if (this.remaining.months > 0) this.mode = this.modes.months;
      else if (this.remaining.days > 0) this.mode = this.modes.days;
      else if (this.remaining.hours > 0) this.mode = this.modes.hours;
      else if (this.remaining.minutes > 0) this.mode = this.modes.minutes;
      if (this.moment.diff(moment()) > 0) this.tick();
    },
  },
  watch: {
    remaining: {
      deep: true,
      handler() {
        this.remainingTime = this.remaining
          ? Object.values(this.remaining).reduce(
              (acc: number, value: number) => acc + value,
              0
            )
          : 0;
      },
    },
    date() {
      this.moment = moment.utc(this.date);
      if (this.moment.isValid()) {
        this.tick(0);
      } else {
        this.error = ["-", "Error"];
      }
    },
  },
});
